import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Facebook, Twitter, Linkedin, Instagram, Send } from "lucide-react";
import { footerInfo, navigation } from "../mock";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setSubscribed(true);
    setEmail("");
    setTimeout(() => setSubscribed(false), 3000);
  };

  return (
    <footer className="bg-[#06183f] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* About */}
        <div>
          <h3 className="text-white font-bold text-lg mb-5 relative pb-3 after:absolute after:left-0 after:bottom-0 after:w-10 after:h-0.5 after:bg-green-500">
            About AKSUBEB
          </h3>
          <p className="text-sm leading-relaxed mb-5">
            The Akwa Ibom State Universal Basic Education Board promotes uniform,
            qualitative and functional basic education for every child of school age
            across the 31 LGAs of Akwa Ibom State.
          </p>
          <div className="flex gap-2">
            {[
              { name: "facebook", Icon: Facebook },
              { name: "twitter", Icon: Twitter },
              { name: "linkedin", Icon: Linkedin },
              { name: "instagram", Icon: Instagram }
            ].map(({ name, Icon }) => (
              <a
                key={name}
                href="#"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-green-600 flex items-center justify-center transition-colors"
                aria-label={name}
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-white font-bold text-lg mb-5 relative pb-3 after:absolute after:left-0 after:bottom-0 after:w-10 after:h-0.5 after:bg-green-500">
            Quick Links
          </h3>
          <ul className="space-y-2.5 text-sm">
            {navigation.map((n) => (
              <li key={n.label}>
                <Link
                  to={n.path}
                  className="hover:text-green-400 transition-colors flex items-center gap-2 before:content-['\203A'] before:text-green-500"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Office Location */}
        <div>
          <p className="uppercase text-xs tracking-widest text-green-400 mb-2">Office Location</p>
          <h3 className="text-white font-bold text-lg mb-5">Contact us today!</h3>
          <p className="text-sm font-bold text-white mb-3">Head Office</p>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3">
              <MapPin size={16} className="flex-shrink-0 mt-0.5 text-green-400" />
              <span>{footerInfo.address}</span>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="flex-shrink-0 mt-0.5 text-green-400" />
              <span>{footerInfo.emails.join("; ")}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="flex-shrink-0 mt-0.5 text-green-400" />
              <span>{footerInfo.phones.join(" / ")}</span>
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h3 className="text-white font-bold text-lg mb-5 relative pb-3 after:absolute after:left-0 after:bottom-0 after:w-10 after:h-0.5 after:bg-green-500">
            Newsletter
          </h3>
          <p className="text-sm leading-relaxed mb-4">
            Subscribe to our newsletter to get the latest updates from AKSUBEB straight to your inbox.
          </p>
          <form onSubmit={handleSubscribe} className="flex">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-4 py-3 bg-white/10 border border-white/20 text-white placeholder:text-slate-400 focus:outline-none focus:border-green-500 text-sm"
            />
            <button
              type="submit"
              className="px-4 bg-green-600 hover:bg-green-700 text-white transition-colors"
            >
              <Send size={18} />
            </button>
          </form>
          {subscribed && (
            <p className="text-green-400 text-xs mt-2">✓ Thank you for subscribing!</p>
          )}
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center text-xs text-slate-400 gap-2">
          <p>© {new Date().getFullYear()} Akwa Ibom State Universal Basic Education Board (AKSUBEB). All rights reserved.</p>
          <p>Setting the PACE in education — Akwa Ibom State, Nigeria.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
